import React, { useEffect, useState } from "react";
import Header from "../layout/Header";
import { formatDatee, formatZuluTime } from "../../helpers/converter";
import { Link, useNavigate } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import { getApplications } from "../../actions/application/getApplications";
import { pagingApplication } from "../../actions/v3/pagingApplications";
import {
  deleteApplication,
  resetDeleteApplication
} from "../../actions/application/deleteApplication";
import Stepper from "../helpers/Stepper";
import Swal from "sweetalert2";
import { useFacility } from "../../context/FacilityContext";

function ApplicationList(props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { setFacility, facility } = useFacility();

  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [applicationStatus, setApplicationStatus] = useState(99);
  const totalCount =
    props.pagingApplication.pagingApplications?.result.totalCount; // Sonuç modelinden gelen toplam kayıt sayısı
  const pageCount = Math.ceil(totalCount / pageSize);

  useEffect(() => {
    dispatch(pagingApplication(pageSize, page, applicationStatus));
  }, [dispatch]);

  useEffect(() => {
    // Burada, sayfa değiştiğinde verileri yeniden yükleme işlevini tetikle
    dispatch(pagingApplication(pageSize, page, applicationStatus));
  }, [page, pageSize, dispatch]);

  const handlePayment = (institutionType, applicationId) => {
    console.log("Seçilen Facility", institutionType);
    
    setFacility(institutionType); // Context API ile facility güncelle
    navigate(`/paymentv2/${applicationId}`);
  };

  // Eğer facility undefined ise hata vermemesi için kontrol ekleyelim
  if (!facility) {
    console.warn("Facility bilgisi bulunamadı, varsayılan olarak 'başkent' atanıyor.");
  }
  
  const handlePrevious = () => {
    setPage((prevPage) => (prevPage > 0 ? prevPage - 1 : prevPage));
  };

  const handleNext = () => {
    setPage((prevPage) => (prevPage < pageCount - 1 ? prevPage + 1 : prevPage));
  };

  const handlePageClick = (pageNumber) => {
    setPage(pageNumber);
  };

  useEffect(() => {
    if (props.deleteApplication.done) {
      Swal.fire({
        title: "Başvuru silindi!",
        icon: "success",
        confirmButtonText: "Tamam",
        confirmButtonColor: "#09c35c"
      });
      dispatch(resetDeleteApplication());
      dispatch(pagingApplication(pageSize, page, applicationStatus));
    }
  }, [props.deleteApplication]);

  return (
    <div>
      <Header />
      <div className="pt-10 md:ml-64 ps-5">
        <ol
          className="flex items-center whitespace-nowrap min-w-0"
          aria-label="Breadcrumb"
        >
          <li
            className="text-sm font-semibold text-gray-800 truncate dark:text-gray-200"
            aria-current="page"
          >
            Başvurularım
          </li>
        </ol>
      </div>
      <hr className="divide-y mt-2" />
      <h1 className="text-2xl font-semibold text-start mt-5 ps-5 md:ml-64">
        Tıbbi İkinci Görüş Başvurularınız
      </h1>
      <p class="mt-5 ps-5 md:ml-64 text-md text-gray-500 text-start mb-">
        Başvurunuzun detaylarını görüntülemek için üzerine tıklayın.
      </p>
      <div className="mb-5">
        {props.pagingApplication.done ? (
          <div className="mt-5 ps-5 md:ml-64 pe-5">
            {props.pagingApplication.pagingApplications?.result?.totalCount ===
            0 ? (
              <div class="bg-red-60 border border-red-200 rounded-md p-4">
                <div class="flex">
                  <div class="ml-3 text-start">
                    <div class="text-sm text-red-700 mt-2">
                      <span class="font-semibold">Başvuru bulunamadı!</span>{" "}
                      Henüz başvurunuz bulunmamaktadır.
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              props.pagingApplication.pagingApplications?.result?.entities.map(
                (element, index) => {
                  return (
                    <>
                      {element.applicationStatus === 0 ||
                      element.applicationStatus === 1 ||
                      element.applicationStatus === 10 ||
                      element.applicationStatus === 3 ||
                      element.applicationStatus === 2 ||
                      element.applicationStatus === 11 ? (
                        <div
                          key={index}
                          class="bg-slate-100 border rounded-sm text-start mb-3"
                        >
                          <div class="top-0 left-0 right-0">
                            <div class="p-4 md:p-5">
                              <div className="flex justify-between">
                                <Link
                                  to={`/application-detail-user/${element.id}`}
                                  className="text-xl font-semibold flex flex-row items-center"
                                >
                                  {element.applicationTargetInstitutionType ===
                                  0 ? (
                                    <div className="hs-tooltip [--placement:right]">
                                      <img
                                        className="mr-4 hs-tooltip-toggle"
                                        src="/assets/images/facilities/baskent.jpg"
                                        width={65}
                                        alt=""
                                      />
                                      <span
                                        class=" hs-tooltip-content hs-tooltip-shown:opacity-100 hs-tooltip-shown:visible opacity-0 transition-opacity inline-block absolute invisible z-10 py-1 px-2 bg-gray-900 text-xs font-medium text-white rounded shadow-sm dark:bg-slate-700"
                                        role="tooltip"
                                      >
                                        Başkent Üniversitesi Hastaneleri
                                      </span>
                                    </div>
                                  ) : element.applicationTargetInstitutionType ===
                                    1 ? (
                                    <div className="hs-tooltip [--placement:right]">
                                      <img
                                        className="mr-4 hs-tooltip-toggle"
                                        src="/assets/images/facilities/erciyesuni.png"
                                        width={75}
                                        alt=""
                                      />
                                      <span
                                        class=" hs-tooltip-content hs-tooltip-shown:opacity-100 hs-tooltip-shown:visible opacity-0 transition-opacity inline-block absolute invisible z-10 py-1 px-2 bg-gray-900 text-xs font-medium text-white rounded shadow-sm dark:bg-slate-700"
                                        role="tooltip"
                                      >
                                        Erciyes Üniversitesi Tıp Fakültesi
                                      </span>
                                    </div>
                                  ) : null}
                                  {element.assignments[0]?.professionName}
                                  <Link
                                    to={`/application-detail-user/${element.id}`}
                                    class="ml-4 text-sm text-blue-600 underline decoration-gray-800 hover:opacity-80 dark:decoration-white"
                                    href="#"
                                  >
                                    Başvuru detayı{" "}
                                    <i class="fa-sharp fa-light fa-arrow-right ml-2"></i>
                                  </Link>
                                </Link>
                                <p className="mt-1 text-xs text-gray-500">
                                  {formatZuluTime(element.createdAt)}
                                  {/* Sil butonunu yalnızca applicationStatus !== 11 olduğunda göster */}
                                  {!element.paymentTransactionId ? (
                                    <button
                                      onClick={() => {
                                        Swal.fire({
                                          title:
                                            "Başvuruyu silmek istediğinize emin misiniz?",
                                          showDenyButton: true,
                                          confirmButtonText: `Evet`,
                                          denyButtonText: `Hayır`,
                                          confirmButtonColor: "#09c35c"
                                        }).then((result) => {
                                          if (result.isConfirmed) {
                                            dispatch(
                                              deleteApplication(element.id)
                                            );
                                          }
                                        });
                                      }}
                                      type="button"
                                      className="ms-2 py-3 px-4 inline-flex items-center gap-x-2 text-sm font-medium rounded-lg border border-gray-200 bg-white text-red-500 shadow-sm hover:bg-gray-50 disabled:opacity-50 disabled:pointer-events-none dark:bg-slate-900 dark:border-gray-700 dark:hover:bg-gray-800 dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600"
                                    >
                                      <i className="fa-light fa-trash"></i>
                                    </button>
                                  ) : null}
                                </p>
                              </div>
                              <div className="d-flex justify-between">
                                <Stepper stateHistory={element.stateHistory} />
                              </div>
                              {/* <p className="mb-3">
                                <b>Başvuru Yapılan Doktor : </b>
                                {element.assignments[0]?.doctor.name +
                                  " " +
                                  element.assignments[0]?.doctor.lastName}
                              </p> */}
                              <>
                                <p className="mt-1">
                                  {element.applicationStatus !== 3 &&
                                  element.applicationStatus !== 6 ? (
                                    <Link
                                      to={`/file-uploadv2/${element.id}`}
                                      className="onedose-color mt-3"
                                    >
                                      <i class="fa-light fa-upload d-flex align-items-center me-1"></i>
                                      Dosya eklemesi yapılabilir.
                                    </Link>
                                  ) : null}
                                  <br />
                                  {element.applicationStatus === 0 ? (
                                    <button
                                      onClick={() =>
                                        handlePayment(
                                          element.applicationTargetInstitutionType ===
                                            0
                                            ? "başkent"
                                            : "erciyes",
                                          element.id
                                        )
                                      }
                                      className={`onedose-color mt-3 ${
                                        element.newStatus === 0
                                          ? ``
                                          : element.newStatus === 11
                                          ? ``
                                          : element.newStatus === 10
                                          ? `hidden`
                                          : element.newStatus === 3
                                          ? `hidden`
                                          : element.newStatus === 2 ||
                                            element.newStatus === 4
                                          ? `hidden`
                                          : element.newStatus === 6
                                          ? `hidden`
                                          : null
                                      }`}
                                    >
                                      <div className="flex justify-center item-center space-x-2">
                                        <i class="fa-duotone fa-credit-card d-flex align-items-center animate-pulse"></i>
                                        <p className="animate-pulse">
                                          Ödemenizi tamamlayabilirsiniz.
                                        </p>
                                      </div>
                                    </button>
                                  ) : null}
                                </p>
                              </>
                            </div>
                          </div>
                        </div>
                      ) : null}
                    </>
                  );
                }
              )
            )}
          </div>
        ) : null}
        {props.pagingApplication.spinner ? (
          <div class="relative mt-5 ps-5 pe-5 md:ml-64">
            <div class="bg-yellow-50 border border-red-200 rounded-md p-4">
              <div class="flex">
                <div class="ml-3 text-start">
                  <h3 class="text-sm text-red-800 font-medium">
                    Detaylar Yükleniyor
                  </h3>
                  <div class="text-sm text-red-700 mt-2">
                    <span class="font-semibold">Lütfen bekleyin!</span> Başvuru
                    detaylarınız getiriliyor.
                  </div>
                </div>
              </div>
            </div>
            <div class="absolute top-0 left-0 w-full h-full bg-white/[.5] rounded-md dark:bg-gray-800/[.4]"></div>
            <div class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
              <div
                class="animate-spin inline-block w-6 h-6 border-[3px] border-current border-t-transparent text-red-600 rounded-full"
                role="status"
                aria-label="loading"
              >
                <span class="sr-only">Loading...</span>
              </div>
            </div>
          </div>
        ) : null}
      </div>
      <nav className="flex items-center gap-x-1 pt-10 md:ml-64 ps-5 float-right me-5">
        <button
          onClick={handlePrevious}
          disabled={page === 0}
          className="min-h-[38px] min-w-[38px] py-2 px-2.5 inline-flex items-center justify-center text-sm rounded-lg text-gray-800 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 disabled:opacity-50 dark:text-white dark:hover:bg-white/10 dark:focus:bg-white/10"
        >
          {/* Geri butonu SVG ve metni burada */}
          <span>Geri</span>
        </button>
        <div className="flex items-center gap-x-1">
          {Array.from({ length: pageCount }, (_, index) => (
            <button
              key={index}
              onClick={() => handlePageClick(index)}
              aria-current={page === index ? "page" : undefined}
              className={`min-h-[38px] min-w-[38px] flex justify-center items-center text-gray-800 hover:bg-gray-100 py-2 px-3 text-sm rounded-lg focus:outline-none focus:bg-gray-100 ${
                page === index
                  ? "disabled:opacity-50 disabled:pointer-events-none"
                  : ""
              } dark:text-white dark:hover:bg-white/10 dark:focus:bg-white/10`}
            >
              {index + 1}
            </button>
          ))}
        </div>
        <button
          onClick={handleNext}
          disabled={page === pageCount - 1}
          className="min-h-[38px] min-w-[38px] py-2 px-2.5 inline-flex items-center justify-center text-sm rounded-lg text-gray-800 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 disabled:opacity-50 dark:text-white dark:hover:bg:white/10 dark:focus:bg:white/10"
        >
          {/* İleri butonu SVG ve metni burada */}
          <span>İleri</span>
        </button>
      </nav>
    </div>
  );
}

const mapStateToProps = (state) => {
  return state;
};

export default connect(mapStateToProps)(ApplicationList);
